import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { DsButton } from '@frontend/ui/button';
import { EffectsModule } from '@ngrx/effects';

import { AffiliateHelperComponent } from './components/affiliate-helper.component';
import { AffiliateWidgetRegistration } from './components/affiliate-widget.registration';
import { AffiliateProcessorService } from './services/affiliate-processor.service';
import AffiliateEffects from './state/affiliate.effects';

@NgModule({
    imports: [FormsModule, EffectsModule.forFeature([AffiliateEffects]), DsButton],
    declarations: [AffiliateHelperComponent],
    exports: [],
    providers: [AffiliateWidgetRegistration, AffiliateProcessorService],
})
export default class BetslipAffiliateModule {
    constructor(affiliateWidgetRegistration: AffiliateWidgetRegistration) {
        affiliateWidgetRegistration.onAppInit();
    }
}
